import { PageSkeleton } from "@client/components/PageSkeleton";
import React from "react";

import { templates } from "@reactivated";

import { Toolbox } from "../components/PageSkeleton/Toolbox";

export const Template = (props: templates.ReusableContentBlockPreview) => (
    <PageSkeleton title="Reusable block preview">
        <Toolbox value={props.object.content.value} />
    </PageSkeleton>
);
